import { render, staticRenderFns } from "./list-formularios.vue?vue&type=template&id=b41b5f26"
import script from "./list-formularios.vue?vue&type=script&lang=ts"
export * from "./list-formularios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports